import React from "react";
import "./Loader.css";
import BrandLogo from "./BrandLogo";
import { t } from "../i18n";

const Loader: React.FC = () => {
  return (
    <div className="loader-overlay">
      <BrandLogo variant="light" alt={t("loader.loading")} className="loader-logo" />
    </div>
  );
};

export default Loader;
